import React from 'react';
import { cn } from '../../../../../lib/utils';
import { primaryText } from '../../../../../styling/stylingHelper';
import { SectionHeadingBlock as SectionHeadingBlockData } from '../../../../../services/admin/cloudAgentTypes';

/** sectionHeading → a plain divider heading (prose pass-through, no data/source). */
export const SectionHeadingBlockAdapter: React.FC<{ block: SectionHeadingBlockData }> = ({ block }) => (
  <h3 className={cn(primaryText, 'text-lg font-semibold pt-2')}>{block.text}</h3>
);
